export interface SpecialTopic {
  id: string;
  title: string;
  intro: string;
  cover: string;
  reason: string;
  eventIds: string[];
}

export const specials: SpecialTopic[] = [
  {
    id: "esports-champion-season",
    title: "2026 秋季电竞冠军季",
    intro:
      "亚洲与世界级电竞赛事密集来到金秋，从上海到首尔，多场冠军争夺战接连打响。本专题聚合本月最值得关注的重量级电竞对决。",
    cover:
      "https://readdy.ai/api/search-image?query=epic%20esports%20championship%20scene%20with%20golden%20trophy%2C%20dark%20arena%20with%20blue%20and%20orange%20stage%20lights%2C%20huge%20crowd%2C%20cinematic%20poster%20style%20photography&width=1200&height=700&seq=special-esports&orientation=landscape",
    reason:
      "三大国际级电竞赛事集中于同一时间段，冠军归属悬念十足，适合追踪赛事脉络与强弱格局变化。",
    eventIds: ["wcg-asia-2026", "kpl-autumn-final", "cs2-major-shanghai", "dota2-ti-qualifier", "valorant-champions"],
  },
  {
    id: "city-sports-festival",
    title: "城市运动狂欢月",
    intro:
      "从马拉松到滑板，从攀岩到篮球，城市成为运动爱好者的主舞台。本专题带你回顾本月最热闹的大众与竞技体育赛事。",
    cover:
      "https://readdy.ai/api/search-image?query=energetic%20city%20sports%20festival%20with%20runners%20and%20skateboarders%2C%20bright%20sunny%20urban%20setting%2C%20colorful%20event%20banners%2C%20vibrant%20lifestyle%20photography&width=1200&height=700&seq=special-sports&orientation=landscape",
    reason:
      "覆盖路跑、球类与极限运动，既有大众参与的热情，也有顶级选手的竞技表现，内容跨度大、观赏性强。",
    eventIds: ["cba-preseason", "china-marathon-cup", "skate-open", "climbing-cup"],
  },
  {
    id: "classic-strategy-week",
    title: "国粹对弈 经典棋局回顾",
    intro:
      "国际象棋、围棋与乒乓球的传统竞技同样精彩。本专题聚焦智力与技巧类赛事，感受冷静博弈背后的深厚功力。",
    cover:
      "https://readdy.ai/api/search-image?query=elegant%20strategy%20games%20theme%20with%20chessboard%20and%20go%20board%2C%20warm%20wood%20tones%2C%20soft%20ambient%20lighting%2C%20refined%20minimal%20interior%2C%20editorial%20photography&width=1200&height=700&seq=special-strategy&orientation=landscape",
    reason:
      "智力与技巧类赛事节奏独特，适合深入阅读与复盘，是理解竞技策略与心理博弈的绝佳素材。",
    eventIds: ["chess-masters", "go-king", "table-tennis-grand"],
  },
];

export const friendlyLinks = [
  { name: "赛事数据中心", url: "/category" },
  { name: "专题策划", url: "/special" },
  { name: "平台介绍", url: "/about" },
  { name: "每日赛程速递", url: "/category" },
  { name: "精彩回放集锦", url: "/special" },
];